import React, { FC, useState } from 'react';

import { DateTime } from 'luxon';
import { ClickAwayListener, TextField } from '@mui/material';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';

import { TimeFormat, userPreferredTimeFormat } from '@pharmaplan/common';

import { useAppSelector } from '../../../hooks/useAppSelector';

import style from './style';

const { twelveHours } = TimeFormat;
interface IInvoiceTimePicker {
  handleTimeChange: (time: DateTime | null) => void;
  currentTime: DateTime;
}

const InvoiceTimePicker: FC<IInvoiceTimePicker> = ({
  handleTimeChange,
  currentTime,
}) => {
  const [open, setOpen] = useState(false);

  const timeFormat = useAppSelector(userPreferredTimeFormat);

  const isTwelveHours = timeFormat === twelveHours;

  const onClose = () => {
    setOpen(false);
  };

  const onOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={onClose}>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <TimePicker
          minutesStep={15}
          open={open}
          ampm={isTwelveHours}
          value={currentTime}
          onOpen={onOpen}
          onClose={onClose}
          onChange={(newValue) => {
            handleTimeChange(newValue);
          }}
          renderInput={(props) =>
            (
              <TextField
              // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
                variant="standard"
                sx={style.textfield}
                inputProps={{
                  ...props.inputProps,
                  placeholder: '00:00',
                  readOnly: true,
                  value: currentTime ? props.inputProps?.value : '',
                }}
              />
            )}
        />
      </LocalizationProvider>
    </ClickAwayListener>
  );
};

export default InvoiceTimePicker;
